/* Accordions (§10.13, §11.1): native <details>/<summary>, so they open without JS and announce
   expanded/collapsed; this only adds the height animation. data-single keeps one item open.
   Selecting a block in the theme editor opens its item. */
class AccordionGroup extends HTMLElement {
  connectedCallback() {
    this.animations = new WeakMap();
    this.onClick = (event) => {
      const summary = event.target.closest('summary');
      if (!summary || !this.contains(summary)) return;
      const details = summary.parentElement;
      const panel = details.querySelector('.acc__panel');
      if (!panel || !window.Theme.motionAllowed()) {
        if (!details.open) this.closeOthers(details, false);
        return; // native toggle
      }
      event.preventDefault();
      if (details.open) this.close(details, panel);
      else this.open(details, panel);
    };
    this.onBlockSelect = (event) => {
      const details = event.target.querySelector?.('details') || event.target.closest?.('details');
      if (details && this.contains(details)) details.open = true;
    };
    this.addEventListener('click', this.onClick);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  closeOthers(details, animate) {
    if (!this.hasAttribute('data-single')) return;
    this.querySelectorAll('details[open]').forEach((other) => {
      if (other === details) return;
      if (animate) this.close(other, other.querySelector('.acc__panel'));
      else other.open = false;
    });
  }

  animate(panel, from, to, fill = 'none') {
    const running = this.animations.get(panel);
    if (running) running.cancel();
    const animation = panel.animate([{ height: from }, { height: to }], { duration: 450, easing: 'cubic-bezier(.3, .8, .2, 1)', fill });
    this.animations.set(panel, animation);
    return animation;
  }

  open(details, panel) {
    this.closeOthers(details, true);
    details.open = true;
    this.animate(panel, '0px', `${panel.scrollHeight}px`);
  }

  close(details, panel) {
    // Hold the collapsed height until <details> is closed, so the panel never flashes open.
    const animation = this.animate(panel, `${panel.offsetHeight}px`, '0px', 'forwards');
    animation.onfinish = () => {
      details.open = false;
      animation.cancel();
      this.animations.delete(panel);
    };
  }
}

if (!customElements.get('accordion-group')) customElements.define('accordion-group', AccordionGroup);
